import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../../utils";
/**
 * Universal page component for consistent layout structure using composition pattern.
 *
 * Usage:
 * ```tsx
 * <Page>
 *   <PageHeader>
 *     <TabNav />
 *   </PageHeader>
 *   <PageContent>
 *     {content}
 *   </PageContent>
 *   <PageFooter>
 *     <BottomBar />
 *   </PageFooter>
 * </Page>
 * ```
 */ const Page = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn("flex h-full flex-col", className),
        ...props
    }));
Page.displayName = "Page";
const PageHeader = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn("sticky top-0 z-10", className),
        ...props
    }));
PageHeader.displayName = "PageHeader";
const PageContent = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn("flex-1 overflow-y-auto p-10", className),
        ...props
    }));
PageContent.displayName = "PageContent";
const PageFooter = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn("", className),
        ...props
    }));
PageFooter.displayName = "PageFooter";
export { Page, PageHeader, PageContent, PageFooter };

//# sourceMappingURL=page.js.map